var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing_one"},[(_vm.footerData)?_c('TheHeader',{attrs:{"appActiveLang":_vm.activeLang}}):_vm._e(),_c('router-view'),(_vm.footerData)?_c('TheFooter',{attrs:{"theFooterData":_vm.footerData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }